import React, { useState, useEffect } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import { useNavigate } from "react-router-dom";
import { handleLogin, handleStudentLogin } from "../api/loginApi";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://yourwebsite.com/">
        Your Website
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

export default function SignIn() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [role, setRole] = useState("");
  const [user, setUser] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const storedUsername = localStorage.getItem("rememberedUsername");
    const storedPassword = localStorage.getItem("rememberedPassword");

    if (storedUsername && storedPassword) {
      setUsername(storedUsername);
      setPassword(storedPassword);
      setRememberMe(true);
    }
  }, []);

  const handleChangeRememberMe = (event) => {
    setRememberMe(event.target.checked);

    if (!event.target.checked) {
      localStorage.removeItem("rememberedUsername");
      localStorage.removeItem("rememberedPassword");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "username") {
      setUsername(value);
    } else if (name === "password") {
      setPassword(value);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (isChecked) {
      handleLogin(
        username,
        password,
        setIsLoggedIn,
        setUser,
        setRole,
        navigate,
        setErrorMessage
      );
      if (rememberMe) {
        localStorage.setItem("rememberedUsername", username);
        localStorage.setItem("rememberedPassword", password);
      } else {
        localStorage.removeItem("rememberedUsername");
        localStorage.removeItem("rememberedPassword");
      }
    } else {
     // alert("Please accept the terms and conditions before logging in.");
    }
  };
  const handleStudentSubmit = (event) => {
    event.preventDefault();
    if (isChecked) {
      handleStudentLogin(
       
        navigate,
        setErrorMessage
      );
      
  };
}

  const openTermsAndConditions = () => {
    window.open("/conditions", "_blank", "noopener,noreferrer");
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="username"
            label="Username"
            name="username"
            autoComplete="username"
            autoFocus
            aria-label="Username"
            value={username}
            onChange={handleChange}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            aria-label="Password"
            value={password}
            onChange={handleChange}
          />
          <FormControlLabel
            control={
              <Checkbox
                value="remember"
                color="primary"
                checked={rememberMe}
                onChange={handleChangeRememberMe}
              />
            }
            label="Remember me"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={isChecked}
                onChange={() => setIsChecked(!isChecked)}
                color="primary"
                aria-required="true"
              />
            }
            label={
              <Typography variant="body2">
                I agree to the{" "}
                <Link
                  component="button"
                  variant="body2"
                  onClick={openTermsAndConditions}
                  underline="hover"
                >
                  terms and conditions
                </Link>{" "}
                regarding the use of cookies and data collection.
              </Typography>
            }
          />
          <Button
            type="submit"
            disabled={!isChecked}
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            aria-label="Sign in"
          >
            Sign In
          </Button>
          <Button
            onClick={handleStudentSubmit}
            disabled={!isChecked}
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            aria-label="Sign in"
          >
            Ohne Anmeldung fortfahren
          </Button>
       
        </Box>
      </Box>
      
    </Container>
  );
}
